/* Ely 10-23, EN-4111: the url of an orders WRITE made from the account level
   as the order's own division (Assign, the risk-hold release, every
   postOrderWrite). It carries the level only (`scope=account`), never the
   division filter; at the division level the url is unchanged. */
import { CommonUtility } from '@utility/common';
import { activeScopeParams } from './active';
import { SCOPE_PARAM, scopeParams } from './scope';

export const scopedWrite = (url: string): string => {
  const atAccount = activeScopeParams()[SCOPE_PARAM] === 'account';
  const extra = CommonUtility.objectToParams(
    scopeParams(atAccount ? 'account' : 'division'),
  );
  return extra ? `${url}?${extra}` : url;
};
